export const CASE_STUDIES = {
  nexa: {
    tagline: "An editorial marketing engine that turns attention into booked strategy calls.",
    brief:
      "NEXA needed to look like the sharpest marketing studio in the room — and prove it with numbers. The brief was tension: bold enough to screenshot, disciplined enough to convert a skeptical founder in under thirty seconds.",
    build:
      "We built the site around an oversized editorial layout and a live growth-chart hero, so the promise of 'marketing that compounds' is demonstrated before a single paragraph is read. Paid media, brand and content services sit in a ruled grid engineered to funnel visitors straight into the strategy-call CTA.",
    process: [
      { title: "Positioning Sprint", desc: "Distilled NEXA's offer into one provable claim — compounding growth — and made it the spine of every page." },
      { title: "Editorial Design System", desc: "Condensed display type, hard rules, and a single acid accent color. A system that reads like a manifesto, not a template." },
      { title: "Conversion Architecture", desc: "Chart-led hero, proof bar of client marks, and one persistent call-to-action placed at every decision point." },
      { title: "Launch & Tuning", desc: "Sub-second loads, 60fps reveals, and analytics wired to track scroll depth against call bookings." },
    ],
    results: [
      { value: "+240%", label: "Qualified engagement" },
      { value: "0.8s", label: "Average page load" },
      { value: "3.1x", label: "Strategy-call bookings" },
    ],
  },
  ridgeline: {
    tagline: "A heavyweight trade brand rebuilt around trust — and a quote funnel that never sleeps.",
    brief:
      "Ridgeline had the craftsmanship but a website that undersold it. Homeowners decide on trust in seconds: warranties, project counts, licensing. The brief was to put proof exactly where the decision happens.",
    build:
      "We paired bold condensed typography with a proof-first layout — 25-year warranty, 1,400+ roofs and licensed status sit directly under the hero, not buried in an about page. A project gallery with location-tagged builds feeds a free-estimate funnel that qualifies leads before the phone rings.",
    process: [
      { title: "Trust Audit", desc: "Mapped every signal a homeowner looks for and rebuilt the page hierarchy around proof, not poetry." },
      { title: "Industrial Visual System", desc: "Navy, safety-orange and condensed type — a brand that reads as durable as the roofs it sells." },
      { title: "Lead Engine Build", desc: "Free-estimate flow with project-type qualifiers, wired to instant notifications for the sales team." },
      { title: "Local Search Domination", desc: "Location-tagged gallery pages structured for regional search from day one." },
    ],
    results: [
      { value: "3.8x", label: "Estimate requests" },
      { value: "1,400+", label: "Roofs showcased" },
      { value: "61%", label: "Quote-form completion" },
    ],
  },
  apex: {
    tagline: "A black-on-black luxury detailing experience that books appointments on sight.",
    brief:
      "Apex Detailing competes on precision — ceramic coatings, paint correction, concours-level finishes. The site needed to feel like the workshop: dark, immaculate, and obsessively detailed, with pricing that pre-sells before the first call.",
    build:
      "We went full cinematic: chrome display type, spotlight car photography, and a package flow that turns browsers into booked appointments. Exterior, ceramic and correction tiers present pricing with zero ambiguity — no 'call for quote' friction anywhere in the funnel.",
    process: [
      { title: "Brand Immersion", desc: "Spent a day in the shop. The lighting rig above every car became the site's signature hero arc." },
      { title: "Dark Luxury System", desc: "True-black palette, metallic gradients and wide-tracked type — luxury cues borrowed from horology, not templates." },
      { title: "Booking Flow Engineering", desc: "Three packages, transparent from-pricing, and a two-step booking path tested to under sixty seconds." },
      { title: "Performance Polish", desc: "Heavy imagery delivered featherweight — lazy-loaded, responsive, and still loading in under a second." },
    ],
    results: [
      { value: "#1", label: "Regional booking rate" },
      { value: "58s", label: "Average time to book" },
      { value: "2.4x", label: "Ceramic package upsell" },
    ],
  },
};
